import { getColor } from "./coloring";

/**
 * Creates paginated data based on the provided key name and input data.
 * Each page can have a maximum of 25 indexes.
 * The data will be sorted based on the key name before pagination.
 *
 * @param {string} keyName - The key name whose value will be used as the 'x' value in the objects.
 * @param {Array<Object>} inputData - The input data array to be paginated.
 * @returns {{
*  [page: number]: {
  *    indexes: Map<string, string>,
  *    data: Array<{
  *      x: string,
  *      y: [number, number],
  *      data: Object
  *    }>
  *  }
  * }} - The paginated data.
  */
export const createPaginatedData = (keyName, inputData, colorBy) => {

  // console.log({ colorBy, keyName });

  if (!keyName || typeof keyName !== 'string' || !inputData || !Array.isArray(inputData)) {
    throw new Error('Invalid input parameters');
  }

  if (keyName === "batch_no") {
    inputData.forEach((data) => {
      // console.log({ data: data[keyName], keyName });
      data[`product_code-batch_no`] = data[`product_code`] + "$-$" + data[keyName]?.substring(0, 8);
    });
    keyName = `product_code-batch_no`;
  } else if (keyName === "product_code") {
    inputData.forEach((data) => {
      // console.log({ data: data[keyName], keyName });
      data[`product_code-batch_no`] = data[`product_code`] + "$-$" + data[`batch_no`]?.substring(0, 8);
    });
    keyName = `product_code-batch_no`;
  }

  // Sort the data based on the key name
  const sortedData = inputData.sort((a, b) => {
    if (a[keyName] < b[keyName]) return -1;
    if (a[keyName] > b[keyName]) return 1;
    return 0;
  });

  // console.log({ sortedData });

  const paginatedData = {};
  let pageIndex = 1;
  let currentPage = { indexes: new Map(), data: [] };
  let current_index = 0;
  // Create paginated data
  for (const obj of sortedData) {
    const index = obj[keyName];
    if (!currentPage.indexes.has(index)) {
      // If the current index is not in the current page's indexes map,
      // create a new page and move the current data to the new page.
      if (currentPage.indexes.size >= 8) {
        paginatedData[pageIndex] = currentPage;
        pageIndex++;
        currentPage = { indexes: new Map(), data: [] };
        current_index = 0;
      }

      // currentPage.indexes.set(index, [current_index]);
    }

    currentPage.data.push({
      x: index,
      y: [obj.start_time.getTime(), obj.end_time.getTime()],
      data: obj,
      fillColor: getColor(keyName, obj[colorBy])
    });
    currentPage.indexes.set(obj[keyName], [...(currentPage.indexes.get(obj[keyName]) || []), current_index]);
    current_index++;
  }

  // Add the last page if it is not empty
  if (currentPage.data.length > 0) {
    paginatedData[pageIndex] = currentPage;
  }

  return paginatedData;
};
